import { render, staticRenderFns } from "./PaymentUserInfo.vue?vue&type=template&id=4dd6d55a&scoped=true"
import script from "./PaymentUserInfo.vue?vue&type=script&lang=js"
export * from "./PaymentUserInfo.vue?vue&type=script&lang=js"
import style0 from "./PaymentUserInfo.vue?vue&type=style&index=0&id=4dd6d55a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd6d55a",
  null
  
)

export default component.exports